<template>
    <DeleteConfirm
        :selectedItem="getSelectedThread"
        :hasToolbar="false"
        :toolbarTitle="$t('Themen Eintrag löschen')"
        :deleteMessage="$t('Sind Sie sicher, dass Sie den folgenden Themeneintrag löschen wollen?')"
        :checkboxDeleteMessage="$t('Diese Aktion kann nicht rückgängig gemacht werden.')"
        @deleteItem="deleteThread"
        @closeEmit="close"
    />
</template>
<script>
import ForumMixin from './Mixins/ForumMixin';
import DeleteConfirm from '../Generic/DeleteConfirm';

export default {
    name: 'delete-thread',
    mixins: [ForumMixin],
    components: {
        DeleteConfirm
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        deleteThread() {
            this.DELETE_FORUM_THREAD({
                forum: this.getSelectedForum,
                thread: this.getSelectedThread
            }).then(() => this.close());
        }
    }
};
</script>
